/**
 * @enum enumSubscriptionPaymentFrequency provides an enumeration of payment frequency for subscription payments.
 * (Note: Try to keep the enumerations in alphabetical order to simplify viewing.)
 */
export enum enumSubscriptionPaymentFrequency {
  Annually = 'Annually',
  Monthly = 'Monthly',
  NoPaymentRequired = 'NoPaymentRequired',
}
